import React from 'react'
import { Select, Tag } from 'antd'

const { Option } = Select

class MediumSelect extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    function tagRender(props) {
      const { value, closable, onClose } = props
      const onPreventMouseDown = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
      return (
        <Tag onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
          {value}
        </Tag>
      )
    }

    return (
      <Select
        placeholder='please select medium'
        {...this.props}
        mode='multiple'
        allowClear
        showArrow
        tagRender={tagRender}
        style={{ width: '100%' }}
      >
        <Option value='painting'>Painting</Option>
        <Option value='drawing'>Drawing</Option>
        <Option value='sculpture'>Sculpture</Option>
        <Option value='collage'>Collage</Option>
        <Option value='installation-digital'>Installation & Digital</Option>
        <Option value='mixed-media'>Mixed Media</Option>
        <Option value='others'>Others</Option>
      </Select>
    )
  }
}

export default MediumSelect
